module.exports = __webpack_public_path__ + "img/search-no-data2.3a5638b4.png";